/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */

/**
 * Created by WJX on 2017/4/24.
 */
import Vue from 'vue';
import config from '@/config/index';
import Api from '@/api/index.js';
var api = new Api();
export default (function (tits, descs, imgs, locationLink, targerUrl, callBack) {
  if (!api.isKln()) {
    locationLink = locationLink || window.location.href;
    var turl = locationLink;

    if (targerUrl) {
      turl = targerUrl;
    }

    Vue.http.post('/rest/ysh/wx/wxIndex/jsApiSignature', {
      url: locationLink
    }).then(function (res) {
      var resp = res.data.data;
      Vue.wechat.config({
        debug: false,
        appId: resp.appId,
        timestamp: resp.timestamp,
        nonceStr: resp.nonceStr,
        signature: resp.signature,
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'previewImage', 'openLocation', 'getLocation']
      });
      Vue.wechat.ready(function () {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        Vue.wechat.onMenuShareTimeline({
          title: tits,
          // 分享标题
          link: turl,
          // 分享链接
          imgUrl: imgs,
          // 分享图标
          success: function success() {
            if (callBack) {
              callBack();
            }
          },
          cancel: function cancel() {}
        });
        Vue.wechat.onMenuShareAppMessage({
          title: tits,
          // 分享标题
          link: turl,
          // 分享链接
          imgUrl: imgs,
          // 分享图标
          desc: descs,
          // 分享描述
          type: 'link',
          // 分享类型,music、video或link，不填默认为link
          dataUrl: '',
          // 如果type是music或video，则要提供数据链接，默认为空
          success: function success() {
            if (callBack) {
              callBack();
            }
          },
          cancel: function cancel() {}
        });
      });
    });
  }
});